
.outer {
    width: 100%;
    height: 1rem;
    background-color: var(--static-background-strong);
    border-radius: 3px;
    overflow: hidden;
}

.inner {
    animation: shimmer 6s infinite linear;
    background: linear-gradient(-45deg, var(--sentiment-background-positive) 45%, var(--sentiment-text-positive) 50%, var(--sentiment-background-positive) 55%);
    background-size: 300%;
    background-position-x: 100%;
    height: 100%;
    padding: 4px;
}

@keyframes shimmer {
    to {
        background-position-x: 0%;
    }
}